'use strict';

var _ = require('lodash');
window.$ = window.jQuery = require('jquery');
$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

require('materialize-css');
require('slick-carousel');
require('sweetalert');
require('./banner');
require('./services');
require('./galery');
require('./newletter');
require('./contact');
let instagramFt=true;

function lazyLoad() {
    let lazyImages = [...document.querySelectorAll('.lazy')];
    lazyImages.forEach(image => {
        if(elementVisible(image)){
            image.src = image.dataset.src;
            image.onload = () => image.classList.add('loaded');
        }
    });
    if(elementVisible($('.instragramImages'))){
        if(instagramFt == true){
            getInstagram();
            instagramFt = false;
        }
    }
}
window.addEventListener('scroll', _.throttle(lazyLoad, 16));
window.addEventListener('resize', _.throttle(lazyLoad, 16));

$(document).ready(function(){
    function cargar(){
        setTimeout(function () {
            $('#loading').css('display','none');
            $('#content').css('visibility','initial');
            $('body').css('overflow-x','visible');
            $('body').css('overflow-y','visible');
            lazyLoad();
        },0);
    }
    window.load = cargar();
    $('.modal').modal({
        dismissible: false,
    });
    $('.sidenav').sidenav({
        edge: 'left',
    });
});

$('.close-menu').click(function () {
    $('.sidenav').sidenav('close');
});


$('.clickAbout').click(function () {
    $('html, body').animate({
        scrollTop: $('#about').offset().top - 100
    }, 1000);
});
$('.clickServices').click(function () {
    $('html, body').animate({
        scrollTop: $('#services').offset().top - 0
    }, 1000);
    setTimeout(function () {
        $('html, body').animate({
            scrollTop: $('#services').offset().top - 0
        }, 500);
    },1100);
});
$('.clickElection').click(function () {
    $('html, body').animate({
        scrollTop: $('#election').offset().top - 100
    }, 1000);
    setTimeout(function () {
        $('html, body').animate({
            scrollTop: $('#election').offset().top - 100
        }, 500);
    },1100);
});
$('.clickGalery').click(function () {
    $('html, body').animate({
        scrollTop: $('#galery').offset().top - 100
    }, 1000);
    setTimeout(function () {
        $('html, body').animate({
            scrollTop: $('#galery').offset().top - 100
        }, 500);
    },1100);
});

$('.clickContact').click(()=>{
   $('.modalContact').modal('open');
});
$(window).scroll(function() {
    if ($(window).width() > 991) {
        if ($(document).scrollTop() > 96) {
            $('.header').css('background','#ffffff');
            $('.header').css('padding','0px 0px');
            $('.header .logo').attr('src',https + 'img/header/logo_down.svg');
            $('.header .menuOpen').attr('src',https + 'img/header/menu_down.svg');
            $('.header .face').attr('src',https + 'img/header/face_down.svg');
            $('.header .ins').attr('src',https + 'img/header/ins_down.svg');
            $('.header').addClass('header-shadow');
        } else if ($(document).scrollTop() >= 0 && $(document).scrollTop() <= 85) {
            $('.header').css('background','transparent');
            $('.header .logo').attr('src',https + 'img/header/logo.svg');
            $('.header .menuOpen').attr('src',https + 'img/header/menu.svg');
            $('.header .face').attr('src',https + 'img/header/face.svg');
            $('.header .ins').attr('src',https + 'img/header/ins.svg');
            $('.header').css('padding','1% 0px');
            $('.header').removeClass('header-shadow');
        }
    }
});

function elementVisible(element){
    var visible = true;
    var windowTop = $(document).scrollTop();
    var windowBottom = windowTop + window.innerHeight;
    var elementPositionTop =  $(element).offset().top;
    var elementPositionBottom = elementPositionTop + $(element).height();
    if (elementPositionTop >= windowBottom || elementPositionBottom <= windowTop) {
        visible = false;
    }
    return visible;
}

setInterval(function () {
    if ($(window).width() > 600) {
        $('.modalContact .description').css('height', $('.modalContact .rowOne').css('height'));
        //$('.containerMap').css('height', $('footer .rowOne').css('height'));
        $('.modalService .banner').css('height', $('.modalService .rowOne').css('height'));
    }
});

$('.modalContact').click(function (e) {
    if($(e.target).parents('.rowOne').length == 0)
        $('.modal').modal('close');
});

function getInstagram() {
    var URL_API_INSTAGRAM = "https://api.instagram.com/v1/users/"+instagram_id+"/media/recent/?count=15&access_token="+instagram_token+"&callback=?";
    $.getJSON(URL_API_INSTAGRAM,function(data) {
        var i = 1;
        $('.instragramImages').html("");
        $.each(data.data, function (item, value) {
            if (i <= 8) {
                $('.instragramImages').append('' +
                    '<div>' +
                        '<a target="_blank" href="' + data.data[item].link + '">' +
                        '   <div class="element">' +
                        '       <div>'+
                        '           <img src="' + value.images.low_resolution.url + '" alt="">' +
                        '       </div>'+
                        '   </div>' +
                        '</a>' +
                    '</div>');
            }
            i++;
        });
        setTimeout(()=>{
            $('#sliderInstagram').slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: false,
                dots: false,
                arrows: true,
                adaptiveHeight: true,
                prevArrow: $('.sliderInstagram .prevArrow'),
                nextArrow: $('.sliderInstagram .nextArrow'),
            });
        },100);
    });
}
